import { fromJS } from 'immutable'

import {
  REQUEST_STATUS_CHANGE
} from './constants'


export const initialState = fromJS({
  status: 'progress',
  message: ''
})


export default function reducer(state = initialState, action) {
  switch(action.type){
    case REQUEST_STATUS_CHANGE:
      return state.merge({
        status: action.status,
        message: action.message
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/components/RequestStatus/reducer.js